import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from 'src/app/auth/components/change-password/change-password.component';
import { ProfileComponent } from 'src/app/auth/components/profile/profile.component';
import { BearerToken } from 'src/app/core/models/bearer.token';
import { CommonConstants } from '../../constant/common.constant';
import {
  AuthService,
  OutletService,
  RestaurantService,
  ToastService,
  TokenService,
  HeaderService,
  DeliveryService,
} from 'src/app/core/services';
import {
  IFilterPaginationDto,
  IThirdPartyDeliveryDto,
} from 'src/app/core/models';

@Component({
  selector: 'ic-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public currentUser: BearerToken;
  public restaurantList: KeyValue<number, string>[];
  public showSearchBox = false;
  public thirdPartyList: IThirdPartyDeliveryDto[];
  public store = {
    web: false,
    webLink: '',
    android: false,
    androidLink: '',
    ios: false,
    iosLink: '',
  } as any;

  constructor(
    private readonly tokenService: TokenService,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    private readonly outletService: OutletService,
    private readonly restaurantService: RestaurantService,
    private readonly headerService: HeaderService,
    private readonly deliveryService: DeliveryService,
    private readonly router: Router,
    private readonly dialog: NgbModal
  ) {
    this.currentUser = this.tokenService.getToken();
    this.showSearchBox =
      this.currentUser.roles ===
      CommonConstants.Role[CommonConstants.Role.Administrator];
  }

  ngOnInit(): void {
    if (this.showSearchBox) {
      this.getRestaurantNames();
    }

    if (this.currentUser && this.currentUser.outletId > 0) {
      this.getOutletFeatures();
    }

    this.authService.isLoggedIn.subscribe((loggedIn) => {
      this.currentUser = this.tokenService.getToken();
    });

    this.authService.isOutletChange.subscribe((outlet) => {
      this.currentUser = this.tokenService.getToken();
      if (this.currentUser.outletId > 0) {
        this.thirdPartyDeliveryList(this.currentUser.outletId);
      } else {
        this.thirdPartyList = [];
      }
      this.validate(this.currentUser);
    });

  }

  validate(token: BearerToken) {
    //const token = this.tokenService.getToken();
    if (token.roles === CommonConstants.Role[CommonConstants.Role.Outlet]) {
      this.store.web = false;
      this.store.android = false;
      this.store.ios = false;
    } else {
      this.store.web = token.restaurantId > 0;
      this.store.webLink = token.rest_url;

      this.store.android = token.isAndroid;
      this.store.androidLink = token.android_url;

      this.store.ios = token.isIos;
      this.store.iosLink = token.ios_url;
    }
  }

  toggleLeftNav() {
    this.headerService.toggleVisibility();
  }

  getOutletFeatures() {
    this.outletService.getOutletFeatures(this.currentUser.outletId).subscribe(
      (data) => {
        this.authService.setOutletFeatures(data);
      },
      (err) => {
        this.toastService.showError(err);
      }
    );
  }

  getRestaurantNames() {
    this.restaurantService.getRestaurantNames().subscribe(
      (data) => {
        this.restaurantList = data;
      },
      (err) => {
        this.toastService.showError(err);
      }
    );
  }

  thirdPartyDeliveryList(id: number) {
    if (this.thirdPartyList && this.thirdPartyList.length > 0) {
      return;
    }
    const filterPaging: IFilterPaginationDto = <IFilterPaginationDto>{
      paging: { sort: {}, skip: 0, take: 100 },
      filter: [
        {
          field: 'outletId',
          operator: CommonConstants.FilterOperator.EQUALTO,
          value: id.toString(),
        },
      ],
    };
    this.deliveryService.getThirdPartyDeliveryList(filterPaging).subscribe(
      (data) => {
        this.thirdPartyList = data;
      },
      (err) => {
        this.toastService.showError(err);
      }
    );
  }

  autoCompleteEvent(event: KeyValue<number, string>) {
    this.restaurantService.getRestaurant(event.key).subscribe((data) => {
      this.authService.updateRestaurant(data, null);
      if (data.outletCount === 1) {
        this.outletService.getOutletFeatures(data.outletId).subscribe(
          (x) => {
            this.authService.setOutletFeatures(x);
            this.authService.updateOutlet(data.outletId, data.outletName);
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => this.router.navigate(['home/dashboard']));
          },
          (err) => {
            this.toastService.showError(err);
          }
        );
      } else {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['home/outlet']));
      }
    });
  }

  editProfile() {
    this.dialog.open(ProfileComponent, {
      backdrop: 'static',
      windowClass: '',
      ariaLabelledBy: '',
      size: '',
    });
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      backdrop: 'static',
      windowClass: '',
      ariaLabelledBy: '',
      size: '',
    });
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate(['/auth']);
    this.toastService.showSuccess('You have been logged out successfully');
  }
}
